import fetch from '@/utils/fetch'

export const List = '/members/agreementRefuseLogList'

export function getAgreementRefuseLogList (params) {
  return fetch({
    url: List,
    method: 'get',
    params
  })
}
